import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Typography } from '@dev/ee-components';
import { CampaignType, TimingOptionEnum } from '@dev/ee-api/ee-api-models';

import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { TimeInputSection } from './components/TimeInputSection';
import { SendXTimes } from './components/SendXTimes';
import { ABReadyToSection } from '../ABReadyToSection/ABReadyTo';
import { useCampaignScreensPathsChecker } from '../hooks/useCampaignScreensPathsChecker';
import { TimingOptionInfo } from '../TimingOptionInfo';

export const ScheduleOptions = (): JSX.Element => {
    const { t } = useTranslation();
    const { campaign } = useSelector(getCampainCreatorStore);
    const isAbCampaign = campaign.Type === CampaignType.AbSplit;
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const timingOpt = campaign?.Options?.TimingOption || TimingOptionEnum.None;

    return (
        <>
            <TimeInputSection type="time" />
            {isAbCampaign ? (
                <ABReadyToSection />
            ) : (
                <>
                    <Typography variant="h3">{t('howmanytimes')}</Typography>
                    <SendXTimes />
                    {!isDetailsScreen && timingOpt !== TimingOptionEnum.None && <TimingOptionInfo />}
                </>
            )}
        </>
    );
};
